import React, {useEffect, useState} from 'react';
import {Button, Modal, Table} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';


const {
  fetchPdsClosedOrdersByTechnician,
} = Actions;

const ClosedOrdersModal = ({filters}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const {closedOrders} = useSelector((state) => state.timeMarked);
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (modalOpened === true) {
      dispatch(fetchPdsClosedOrdersByTechnician(filters.technicianSelected));
    }
  }, [modalOpened]);

  return (
    <Modal size='large' className='stock-download-modal' open={modalOpened}
      trigger={
        filters.technicianSelected === 'PDS' ?
          <Button onClick={(e, value) => setModalOpened(true)} >
            Cerradas
          </Button> : ''
      }>
      <Modal.Header>
        Ordenes Cerradas
      </Modal.Header>
      
      <Modal.Content scrolling>
        <Modal.Description>
          <Table className='interactive' striped>
            <Table.Header className='orders-table-header commercial-sticky-header'>
              <Table.Row>
                <Table.HeaderCell>Orden</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Color</Table.HeaderCell>
                <Table.HeaderCell>Chasis</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                closedOrders?.map((order, index) => {
                  return (
                    <Table.Row key={order.order}>
                      <Table.Cell>{order.order}</Table.Cell>
                      <Table.Cell>{order.description}</Table.Cell>
                      <Table.Cell>{order.color}</Table.Cell>
                      <Table.Cell>{order.chassis}</Table.Cell>
                    </Table.Row>
                  );
                })
              }
            </Table.Body>
            {/* {list.length > pageSize && (
              <Table.Footer>
                <Table.Row textAlign='center'>
                  <Table.HeaderCell colSpan='100%'>
                    <div className='table-pagination'>
                      <span className='page-sizer'>
                        <strong>Items por página</strong>
                        <Dropdown
                          selection
                          upward
                          compact
                          value={pageSize}
                          options={pageSizes}
                          onChange={handlePageResize}
                        />
                      </span>
                      <TablePaginator
                        itemsCount={list.length}
                        itemsPerPage={pageSize}
                        selectedPage={page}
                        onOptionClick={handlePageChange}
                      />
                    </div>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            )} */}
          </Table>
        </Modal.Description>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={(e, value) => setModalOpened(false)}>
          Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ClosedOrdersModal;
